import { FitnessLevel } from 'constants/user';
import { COMPLEXITY_LEVELS_ARR, DEFAULT_BACKGROUND_VOLUME, DEFAULT_VOLUME, VOLUME_KEY_IN_LS } from 'constants/workout';

import isMobile from 'helpers/isMobile';

import { IWorkoutExtended } from 'types/personalPlan';

import { BigScreenMediaTypes } from '../types/bigScreen';

export const splitSecondsByHMS = (seconds: number) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    return {
        hrs: hrs < 10 ? `0${hrs}` : hrs,
        mins: mins < 10 ? `0${mins}` : mins,
        secs: secs < 10 ? `0${secs}` : secs,
    };
};

export const fancyTime = (seconds: number, isFullTime?: boolean): string => {
    const { hrs, mins, secs } = splitSecondsByHMS(seconds);
    const fancyMinutesAndSeconds = `${mins}:${secs}`;

    if (Number(hrs) > 0 || isFullTime) {
        return `${hrs}:${fancyMinutesAndSeconds}`;
    }

    return fancyMinutesAndSeconds;
};

export const getInitialVolume = (mediaType?: BigScreenMediaTypes): number => {
    if (mediaType === BigScreenMediaTypes.BgMusic) return DEFAULT_BACKGROUND_VOLUME;

    const valueFromLS = localStorage.getItem(VOLUME_KEY_IN_LS);

    if (valueFromLS) return Number(valueFromLS);

    return isMobile.any() ? 1 : DEFAULT_VOLUME;
};

export const increaseComplexityLevel = (currentLevel: FitnessLevel) => {
    let isPossibleToIncreaseLevel, newLevel;

    if (currentLevel === FitnessLevel.Advanced) {
        isPossibleToIncreaseLevel = false;
        newLevel = currentLevel;
    } else {
        const currentLevelIndex = COMPLEXITY_LEVELS_ARR.indexOf(currentLevel);

        isPossibleToIncreaseLevel = true;
        newLevel = COMPLEXITY_LEVELS_ARR[currentLevelIndex + 1];
    }

    return {
        newLevel,
        isPossibleToIncreaseLevel,
    };
};

export const isLastDayOfThePlan = (currentDay: number, totalDays: number): boolean => currentDay === totalDays;

export const isFirstDayOfThePlan = (currentDay: number): boolean => currentDay === 1;

export const isWholePlanCompleted = (workouts: IWorkoutExtended[]): boolean =>
    Boolean(workouts[workouts.length - 1].completion_date);
